import './ModuleWindow.css';
import { useStore } from '../../store/store';
import { translations } from '../../configs/translations';

export interface ModuleWindowProps {
    title: string;
    text: string;
    onYes: () => void;
    onNo: () => void;
    type?: ModuleWindowType
    inputValue?: string | number | null 
    setInputValue?: (value: string | number) => void
    inputPrice?: string | number | null
    setInputPrice?: (value: string | number) => void
}

export type ModuleWindowType = 'default' | 'with-input-battlepass';

export const ModuleWindow = (props: ModuleWindowProps) => {
    if (props.type === 'with-input-battlepass') {
        return <ModuleWindowWithInputBattlepass {...props} />
    }

    return <ModuleWindowDefault {...props} />
}

export const ModuleWindowDefault = (props: ModuleWindowProps) => {
    const language = useStore(state => state.language) as keyof typeof translations;
    const t = translations[language];

    return (
        <div className="module-window-wrapper">
            <div className="module-window">
                <div className="module-window-header">
                    <p>{props.title}</p>
                </div>    

                <div className='module-window-text'>
                    <p>{props.text}</p>
                </div>

                <div className='module-window-buttons'>
                    <div
                        onClick={props.onYes}
                        className='module-window-button primary'
                    >
                        <p>{t.yes}</p>
                    </div>
                    <div
                        onClick={props.onNo}
                        className='module-window-button secondary'
                    >
                        <p>{t.no}</p>
                    </div>
                </div>
            </div>
        </div>
    )
}

export interface ModuleWindowWithInputBattlepassProps {
    title: string;
    text: string;
    onYes: () => void;
    onNo: () => void;
    inputValue?: string | number | null;
    setInputValue?: (value: string | number) => void;
    inputPrice?: string | number | null;
    setInputPrice?: (value: string | number) => void;
}

export const ModuleWindowWithInputBattlepass = (props: ModuleWindowWithInputBattlepassProps) => {
    const language = useStore(state => state.language) as keyof typeof translations;
    const t = translations[language];

    return (
        <div className="module-window-wrapper">
            <div className="module-window">
                <div className="module-window-header">
                    <p>{props.title}</p>
                </div>    

                <div className='module-window-input'>
                    <input 
                        placeholder={t.enter_amount} 
                        type="number" 
                        value={props.inputValue as number} 
                        onChange={(e) => {
                            props.setInputValue?.(e.target.value)
                        }} 
                    />
                    <p
                        style={{
                            fontSize: '22px',
                            maxWidth: '70%',
                        }}
                    >
                        {props.text}
                    </p>
                </div>

                <div className='module-window-buttons'>
                    <div
                        onClick={props.onYes}
                        className='module-window-button primary'
                        style={{
                            width: '400px',
                            height: '60px',
                        }}
                    >
                        <p>{t.buy}: {props.inputPrice || 0} DP</p>
                    </div>
                    <div
                        onClick={props.onNo}
                        className='module-window-button secondary'
                        style={{
                            width: '150px',
                            height: '60px',
                        }}
                    >
                        <p>{t.cancel}</p>
                    </div>
                </div>
            </div>
        </div>
    )
}